import './styles.scss'
import React from 'react'
import { COFFEE_CART } from 'Utils/Constants'
import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'

const CoffeeCart = () => {
  const userDetails = getLocalUserDetails()

  return (
    <div className={`coffee-cart-container ${userDetails?.id ? 'logged-in' : 'guest-user'}`}>
      <video controls className="coffee-cart-image" autoPlay loop playsInline>
        <source src={COFFEE_CART.video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  )
}

export default CoffeeCart
